export default __webpack_public_path__ + "static/media/MM-Seas-LogoReversed.9c58121a.svg";